<template>
  <el-dialog
    title="加入/移出群組"
    fullscreen
    @close="handleDlgClose"
    :visible.sync="innerVisible"
  >
    <div class="container" v-loading="isLoading">
      <div class="row justify-content-between">
        <div class="px-2">
          <el-form
            ref="queryForm"
            :model="queryForm"
            label-width="100px"
            :inline="true"
            @keyup.enter.native="handleQueryClick(queryForm)"  @submit.native.prevent
          >
            <el-form-item label="關鍵字">
              <el-input
                v-model="queryForm.qstr"
                placeholder="群組名稱"
                size="small"
              ></el-input>
            </el-form-item>

            <el-form-item>
              <el-button
                type="primary"
                @click="handleQueryClick(queryForm)"
                size="small"
                >查詢</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div>
          <el-button
            type="primary"
            @click="handleBatchJoin"
            size="small"
            :disabled="selectedRow.length === 0"
            >批次加入群組</el-button
          >

          <el-button
            type="danger"
            @click="handleBatchQuit"
            size="small"
            :disabled="selectedRow.length === 0"
            >批次移出群組</el-button
          >
        </div>
      </div>
    </div>

    <CCard>
      <CCardHeader>
        <CIcon name="cil-user" /> 人員編號：{{ memberNo }} / 人員名稱：{{
          memberName
        }}
      </CCardHeader>
      <CCardBody>
        <CRow>
          <el-table
          :border="true"
            v-loading="isLoading"
            ref="dataTable"
            @selection-change="handleSelectionChange"
            :data="groups"
            @sort-change="sortChange"
            :default-sort="{ prop: 'id', order: 'ascending' }"
            stripe
            style="width: 100%"
          >
            <el-table-column type="selection" width="45"> </el-table-column>

            <el-table-column
              prop="id"
              type="index"
              :index="indexFormatter"
              fixed
            >
            </el-table-column>

            <el-table-column label="所屬部門" prop="deptName" width="150">
              <template #default>
                {{ deptName }}
              </template>
            </el-table-column>

            <el-table-column
              label="群組名稱"
              prop="name"
              sortable="custom"
              width="200"
            >
              <template #default="scope">
                <el-tag :style="getTagStyle(scope.row.color)">{{ scope.row.name }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column label="加入群組">
              <template #default="scope">
                <el-switch
                  :value="isJoinedGroup(scope.row)"
                  active-text="是"
                  inactive-text="否"
                  :disabled="isSwitchDisabled(scope.$index)"
                  v-loading="isSwitchDisabled(scope.$index)"
                  @change="
                    isMember => setMember(isMember, scope.row, scope.$index)
                  "
                >
                </el-switch>
              </template>
            </el-table-column>
          </el-table>
        </CRow>

        <CRow>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[50, 100, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </CRow>
      </CCardBody>
    </CCard>

    <template #footer class="dialog-footer">
      <el-button @click="innerVisible = false">關閉</el-button>
    </template>
  </el-dialog>
</template>

<script>
import API from "@/api/";
import { mapGetters } from "vuex";
import tagColorsMixin from "@/components/mixin/tagColors.js";
export default {
  mixins: [tagColorsMixin],
  model: {
    prop: "visible",
    event: "toggleVisible",
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    memberId: {
      type: Number,
      default: null,
    },
    memberNo: {
      type: String,
      default: null,
    },
    memberName: {
      type: String,
      default: null,
    },
    deptId: {
      type: Number,
      default: null,
    },
    deptName: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters({
      myownOrg: "auth/orgName",
      groups: "group/groups",
      total: "group/total",
      offset: "group/offset",
      sort: "group/sort",
      order: "group/order",
    }),
    innerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("toggleVisible", val);
      },
    },
  },
  data() {
    return {
      isLoading: false,
      disabledSwitchIdx: [],
      selectedRow: [],
      formLabelWidth: "100px",
      pageSize: 50,
      currentPage: 1,
      queryForm: {
        qstr: "",
      },
      activeQueryForm: {
        qstr: "",
      },
    };
  },
  created() {
    //NOTE: reset group store; otherwise the table may read the old groups data in the store before getting the new groups data. The old groups data may not contains the required "groupDeptMembers" attribute, if it's gotten from DeptGroupList. See G_TREASURE-86
    this.$store.commit("group/CLEAR");
    if (this.innerVisible) {
      //NOTE: always start from the first page
      this.query(this.pageSize, 0, this.sort, this.order);
    }
  },
  methods: {
    isSwitchDisabled(idx) {
      return this.disabledSwitchIdx.includes(idx);
    },

    batchHandler(isSkipped, actionFunc, successMsg) {
      let promises = [];
      this.isLoading = true;
      let runningItem = [];
      let failedItem = [];
      this.selectedRow.forEach(row => {
        if (!isSkipped(row)) {
          runningItem.push(row);
          promises.push(actionFunc(row, null, false, false));
        }
      });

      Promise.allSettled(promises)
        .then(results => {
          results.forEach((res, idx) => {
            //if (res.status === "fulfilled") {
            //this.$refs.dataTable.toggleRowSelection(this.members[selectedIdx[idx]], false);
            //}
            if (res.status === "rejected") {
              //console.log(`rejected: pushed name = ${runningItem[idx].name}`);
              failedItem.push(runningItem[idx].name);
              //this.$refs.dataTable.toggleRowSelection(this.members[selectedIdx[idx]], true);
            }
          });

          //console.log(`failedItem = ${JSON.stringify(failedItem)}`);
          if (!failedItem.length) {
            this.$message.success(successMsg);
          } else {
            this.$message.error("部分項目發生錯誤!");
          }
        })
        .finally(() => {
          this.query(
            this.pageSize,
            this.offset,
            this.sort,
            this.order,
            this.activeQueryForm
          ).then(() => {
            failedItem.forEach(failedName => {
              const failedOne = this.groups.find(
                item => item.name === failedName
              );
              failedOne &&
                this.$refs.dataTable.toggleRowSelection(failedOne, true);
            });
            //NOTE: we intentionally set loading to false ONLY when query succeeds
            this.isLoading = false;
          });
        });
    },

    handleBatchJoin() {
      const isSkipped = row => (this.isJoinedGroup(row) ? true : false);
      this.batchHandler(isSkipped, this.joinGroup.bind(this), "批次加入成功");
    },
    handleBatchQuit() {
      const isSkipped = row => (!this.isJoinedGroup(row) ? true : false);
      this.batchHandler(isSkipped, this.quitGroup.bind(this), "批次移出成功");
    },

    handleSelectionChange(rows) {
      //console.log(`handleSelectionChange: val = ${JSON.stringify(rows)}`);
      this.selectedRow = rows;
    },
    setMember(isMember, grp, index) {
      const isChecked = this.selectedRow.find(row => row.name === grp.name);
      let p;
      this.disabledSwitchIdx.push(index);
      if (isMember) {
        p = this.joinGroup(grp, index);
      } else {
        p = this.quitGroup(grp, index);
      }
      p.finally(() => {
        isChecked &&
          this.$refs.dataTable.toggleRowSelection(this.groups[index], true);

        const found = this.disabledSwitchIdx.indexOf(index);
        found !== -1 && this.disabledSwitchIdx.splice(found, 1);
      });
    },

    joinGroup(grp, index, updateStore = true, showMsg = true) {
      const params = {};
      params.groupId = grp.id;
      params.memberId = this.memberId;
      return API.groupDeptMember.add(params).then(res => {
        if (updateStore) {
          const newGrp = { ...grp };
          const groupDeptMembers = [{}];
          groupDeptMembers[0].id = res.data.id;
          newGrp.groupDeptMembers = groupDeptMembers;

          const payload = {};
          payload.newGrp = newGrp;
          payload.index = index;
          this.$store.commit("group/CHANGE_GROUP", payload);
        }

        showMsg &&
          this.$message({
            type: "success",
            message: "加入成功!",
          });
        return res;
      });
    },

    quitGroup(grp, index, updateStore = true, showMsg = true) {

      return API.groupDeptMember
        .remove(grp.groupDeptMembers[0].id)
        .then(res => {
          if (updateStore) {
            const newGrp = { ...grp };
            newGrp.groupDeptMembers = [];

            const payload = {};
            payload.newGrp = newGrp;
            payload.index = index;
            this.$store.commit("group/CHANGE_GROUP", payload);
          }

          showMsg &&
            this.$message({
              type: "success",
              message: "移除成功!",
            });
          return res;
        });
    },

    isJoinedGroup(grp) {
      if (!grp.groupDeptMembers) {
        console.warn(
          `isJoinedGroup: grp.groupDeptMembers is undefined, grp = ${JSON.stringify(
            grp
          )}`
        );
      }
      return grp.groupDeptMembers.length > 0 ? true : false;
    },

    handleQueryClick(queryForm) {
      this.currentPage = 1; //reset pagination to the first page
      this.activeQueryForm = { ...queryForm };
      this.query(this.pageSize, 0, this.sort, this.order, this.activeQueryForm);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.query(val, this.offset, this.sort, this.order, this.activeQueryForm);
    },
    handleCurrentChange(page) {
      this.query(
        this.pageSize,
        this.pageSize * (page - 1),
        this.sort,
        this.order,
        this.activeQueryForm
      );
    },
    query(max, offset, sort, order, params = {}) {
      //console.log(`EditMbrGroupDlg: memberId = ${this.memberId}`)
      return this.$store
        .dispatch("group/list", {
          dept: this.deptId,
          member: this.memberId,
          max: max,
          offset: offset,
          sort,
          order,
          ...params,
        })
        .finally(() => {
          this.disabledSwitchIdx = [];
        });
    },
    indexFormatter(index) {
      return `#${parseInt(this.offset) + index + 1}`;
    },
    sortChange(args) {
      if (args.order === null) {
        this.$store.commit("group/SET_SORT", "id");
        this.$store.commit("group/SET_ORDER", "ascending");
      } else {
        this.$store.commit("group/SET_SORT", args.prop);
        this.$store.commit("group/SET_ORDER", args.order);
      }
      this.query(
        this.pageSize,
        this.offset,
        this.sort,
        this.order,
        this.activeQueryForm
      );
    },
    handleDlgClose() {
      //this.$store.dispatch('member/list', null);
    },
  },
};
</script>

<style></style>
